import type { contactUsMessage, errorMessage } from "~/core/interfaces/common";

export default function getSendUsAMessageLogic() {
  const isLoading = ref<boolean>(false);
  async function sendUsAMessage(
    messageInfo: contactUsMessage,
    onSuccess: () => void,
    onFailure: (message: string) => void
  ) {
    isLoading.value = true;
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    try {
      await $fetch(`${useRuntimeConfig().public.techaliApiBase}/ContactUs`, {
        method: "POST",
        body: JSON.stringify(messageInfo),
        headers: headers,
        // mode: "no-cors",
        redirect: "follow",
        onRequestError: (_) => {
          throw <errorMessage>{
            statusCode: 503,
            errorCode: "REQUEST_TIMEOUT",
            message: "Make sure you have a working internet connection",
          };
        },
        onResponse: (ctx) => {
          console.log("Maaz");
          console.log(ctx);
          if (ctx.response.status !== 200) {
            throw <errorMessage>{
              statusCode: 503,
              errorCode: "SERVER_ERROR",
              message: "Server error occured. Please try again.",
            };
          }
        },
      });
      isLoading.value = false;
      onSuccess();
    } catch (e: any) {
      isLoading.value = false;
      if (e.message) {
        onFailure(e.message);
      } else {
        onFailure("Unknown error occured");
      }
    }
  }

  return {
    isLoading,
    sendUsAMessage,
  };
}
